// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__aC0je","SubTitle":"style_SubTitle__xqRi9","ListItem":"style_ListItem__1ciRD","ContentBlock":"style_ContentBlock__5sM7Y","Link":"style_Link__p38tx"};